module.exports = __webpack_public_path__ + "media/images/landing/background-circles-20ddf30e1996ef7f3d3c6fed7c9b600a.jpg";